import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/pro-regular-svg-icons';

export const MobilePage = ({ headerTitle, goBack, children }) => (
  <div className="ct-mobile-page">
    <div className="ct-mobile-page__header">
      <div className="ct-mobile-page__fixed-header" onClick={goBack}>
        <FontAwesomeIcon icon={faAngleLeft} />
        {headerTitle}
      </div>
    </div>
    <div className="ct-mobile-page__content">{children}</div>
  </div>
);
